module.exports = __webpack_public_path__ + "img/salades_md.e32d1028.jpg";